/** Inv.SessionBatches.DeadlineChangeTypeId: the last decision that reset the answer deadline (LEG-251 BR-13). */
export enum InvestigationDeadlineChangeType {
	Renotify = 1,
	Extend = 2,
}
